import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import UpgradePointButton from 'personalization-lib/components/shared/upgrades/UpgradePointButton';
import BetaBadge from 'personalization-lib/components/shared/badges/BetaBadge';
import withInlineErrorHandling from 'personalization-lib/components/shared/hocs/withInlineErrorHandling';
import useContentEditorVariantCreation from 'personalization-lib/hooks/variantCreation/useContentEditorVariantCreation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentEditorCreateVariantButton = ({
  label,
  upgradeKey,
  buttonProps = {},
  tooltipProps = {},
  showBetaBadge
}) => {
  const {
    openPanel,
    tooltip,
    loading,
    error,
    isVisible,
    isDisabled,
    isUpgradeRequired
  } = useContentEditorVariantCreation({
    trackingProps: {
      actionSource: 'content_editor_button'
    }
  });
  const defaultLabel = I18n.text('personalizationLib.createVariantButton.label.unified');
  if (!isVisible) {
    return null;
  }
  if (isUpgradeRequired && upgradeKey) {
    return /*#__PURE__*/_jsx(UpgradePointButton, Object.assign({
      upgradeKey: upgradeKey,
      "data-test-id": "content-editor-create-variant-button-upgrade"
    }, buttonProps, {
      children: label || defaultLabel
    }));
  }
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({}, tooltipProps, {
    title: tooltip,
    disabled: !isDisabled,
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
      onClick: openPanel,
      "data-test-id": !loading && !error && 'content-editor-create-variant-button',
      "data-onboarding-target": "content-editor-create-variant-button",
      disabled: isDisabled || buttonProps.disabled,
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "200",
        alignItems: "center",
        children: [label || defaultLabel, showBetaBadge && /*#__PURE__*/_jsx(BetaBadge, {})]
      })
    }))
  }));
};
export default withInlineErrorHandling(ContentEditorCreateVariantButton);